import service from './src/index';

export default {
    install(Vue) {
        Vue.prototype.$hour2happy = service;
    },
    service
}